import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=cd563202&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=cd563202&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd563202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd563202')) {
      api.createRecord('cd563202', component.options)
    } else {
      api.reload('cd563202', component.options)
    }
    module.hot.accept("./UserProtocol.vue?vue&type=template&id=cd563202&scoped=true", function () {
      api.rerender('cd563202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/Docs/vibeo/UserProtocol.vue"
export default component.exports